import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import '../styles.scss'
import PropTypes from 'prop-types'
import Bars from '../../../../../../Shared/Bars'
import { constants } from '../../../../../../../constants'
import ProLabel from '../../../../../../Shared/ProLabel'
import {
  getDestinationScoresAvg,
  getDestinationScoresTop,
  getScores,
} from '../../../../../../../http/driveApiGateway/client'

class SingleGraphTable extends Component {
  constructor (props) {
    super(props)
    const { t } = this.props
    this.state = {
      rings: {
        values: [
          { deg: -1, value: false, label: t('LABEL_MY_HOTEL') },
          { deg: -1, value: false, label: t('LABEL_MY_AREA') + '*' },
          { deg: -1, value: false, label: t('LABEL_MY_WORLD') + '*' }
        ],
        sum: false,
        sum_subline: false
      },
      tableData: []
    }
  }

  componentDidMount () {
    this.updateData()
  }

  // noinspection JSCheckFunctionSignatures
  componentDidUpdate (prevProps, prevState) {
    if (
      this.props.activeHotel.id !== prevProps.activeHotel.id
      || this.props.widget !== prevProps.widget
    ) {
      this.updateData()
    }
  }

  setScoreData (scoresData, ringId) {
    if (scoresData.error === undefined) {
      this.setState((prevState) => {
        // noinspection JSUnresolvedReference
        const percentage = scoresData.scores[scoresData.scores.findIndex(s => s.id === this.props.widget.scoreId)].percentage
        const rings = Object.assign({}, prevState.rings)
        rings.values[ringId].deg = percentage * 270
        rings.values[ringId].value = Math.ceil(percentage * 100)
        return {
          ...prevState,
          rings
        }
      })
    }
  }

  updateData () {
    const { t } = this.props
    let giataId = this.props.activeHotel.attr[constants.attributePaths.giataId][1].data.code
    const overrideImageCount = this.props.widget?.overrideImageCount ?? null
    getScores(giataId, overrideImageCount).fetchPromise.then((scoresData) => {
      this.setScoreData(scoresData, 0)
      let scores = scoresData.scores[scoresData.scores.findIndex(s => s.id === this.props.widget.scoreId)]
      // noinspection JSUnresolvedReference
      const rings = Object.assign({}, this.state.rings)
      rings.sum = Math.ceil(scores.percentage * 100) + '%'
      if (this.props.widget.scoreId === 3 || this.props.widget.scoreId === 4) {
        rings.sum_subline = scores.value + ' ' + t(this.props.widget.mainValueLabel, { count: scores.value })
      }
      this.setState({
        rings
      })
    })
    getDestinationScoresAvg(this.props.activeHotel.attr[constants.attributePaths.destination][1].data.href)
      .fetchPromise.then((scoresData) => {
      this.setScoreData(scoresData, 1)
    })
    getDestinationScoresTop(this.props.activeHotel.attr[constants.attributePaths.destination][1].data.href, this.props.widget.scoreId)
      .fetchPromise.then((scoresData) => {
      this.setScoreData(scoresData, 2)
    })
  }

  render () {
    return (
      <div className="Widget Widget-Graph">
        <div className="Widget-Content">
          <h3><Trans>{this.props.widget.title}</Trans></h3>
          {constants.scores.types[this.props.widget.scoreId].pro &&
            <ProLabel/>
          }
          <small className="Widget-ScoresHint"><span>*</span> Hotels in your destination</small>
          <Bars className={'Bars-score-' + this.props.widget.scoreId} values={this.state.rings}></Bars>
        </div>
      </div>
    )
  }
}

SingleGraphTable.defaultProps = {}
SingleGraphTable.propTypes = {
  activeHotel: PropTypes.object.isRequired,
  widget: PropTypes.shape({
    scoreId: PropTypes.number.isRequired,
    mainValueLabel: PropTypes.string.isRequired,
    overrideImageCount: PropTypes.number
  }).isRequired,
}
export default withTranslation()(SingleGraphTable)
